import React from 'react';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { offer_networkId } from '../../../utils/query-helpers';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          ...offer_networkId(network),
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
